import './App.css';
import GlobalStore from "./global/GlobalStore";
import Login from './login'


function App() {
  
  return (
    <GlobalStore>
      <Login></Login>
    </GlobalStore>

  );
}

export default App;
